import React from 'react';
import axios from 'axios';
import ReactDOM from 'react-dom';
import Swal from 'sweetalert2';
import routes from '../../../utils/routes';

const DeleteConfirmationModal = ({
  onRequestDelete,
  requestId,
}) => {
  return (
    <div
      className="modal fade"
      id="deleteFormModal"
      tabIndex={-1}
      role="dialog"
      aria-label="Delete form."
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5
              className="modal-title"
              id="exampleModalLabel"
            >
              Delete Form Submission
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span
                aria-hidden="true"
              >
                &times;
              </span>
            </button>
          </div>
          <div className="modal-body">
            <p>Would you like to this delete this form submission?</p>
            <p>(This action cannot be undone.)</p>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="submit btn btn-danger"
                onClick={() => onRequestDelete(requestId)}
              >
                Yes, delete
              </button>
            </div>
          </div>
          Î
        </div>
      </div>
    </div>
  );
};

const AccountDeletionRequestDeleteButton = ({ accountDeletionRequest }) => {
  const handleDelete = async (requestId: number) => {
    try {
      const response = await axios.delete(routes.adminDeleteFormsAccountDeletionRequest(requestId));
      Swal.fire({
        title: 'Success',
        text: response.data.message,
        icon: 'success',
      })
        .then(() => window.location.replace(routes.ACCOUNT_DELETION_REQUEST_INDEX));
    } catch (error: any) {
      const message = error.response?.data?.message || error.message || 'Something went wrong; please try again.';
      await Swal.fire('Error', message, 'error');
    }
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-danger"
        data-toggle="modal"
        data-target="#deleteFormModal"
      >
        Delete Request
      </button>
      <DeleteConfirmationModal
        onRequestDelete={handleDelete}
        requestId={accountDeletionRequest.id}
      />
    </>
  );
};

const elem = document.getElementById('react-account-deletion-request-delete-button');
if (elem) {
  const accountDeletionRequest = JSON.parse(elem.getAttribute('data-account-deletion-request') || '{}');
  ReactDOM.render(<AccountDeletionRequestDeleteButton
    accountDeletionRequest={accountDeletionRequest}
  />, elem);
}
